import React, { useState, useEffect } from "react";
import { Grid, Typography, Box, Button, Chip, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter, useParams } from "react-router-dom";
import AdminEventService from "../dashboard/Locality/Service/adminEventService";
import Header from "./Header";
import Footer from "./Footer";
import './styles/bootstrap.min.css';
import './styles/main.css';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import PersonIcon from '@material-ui/icons/Person';
import LanguageIcon from '@material-ui/icons/Language';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ShareIcon from '@material-ui/icons/Share';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import MyLocationIcon from '@material-ui/icons/MyLocation';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(4),
        paddingTop: '120px', // Add top padding to account for sticky header
        minHeight: 'calc(100vh - 120px)',
        backgroundColor: '#fff',
        marginTop: 0,
        position: 'relative',
        zIndex: 1,
    },
    contentContainer: {
        maxWidth: '1200px',
        margin: '0 auto',
        paddingTop: 0,
    },
    backButton: {
        marginBottom: theme.spacing(2),
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        color: '#666',
        '&:hover': {
            color: '#ff6b81',
        },
    },
    headerSection: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    eventTitle: {
        fontSize: '2rem',
        fontWeight: 'bold',
        color: '#333',
    },
    imageContainer: {
        position: 'relative',
        width: '100%',
        minHeight: '400px',
        maxHeight: '600px',
        height: 'auto',
        borderRadius: '8px',
        overflow: 'hidden',
        marginBottom: theme.spacing(2),
        backgroundColor: '#f5f5f5',
    },
    eventImage: {
        width: '100%',
        height: '100%',
        minHeight: '400px',
        maxHeight: '600px',
        objectFit: 'contain',
        objectPosition: 'center',
        display: 'block',
    },
    carouselButton: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        color: '#333',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
        },
    },
    leftButton: {
        left: theme.spacing(2),
    },
    rightButton: {
        right: theme.spacing(2),
    },
    carouselDots: {
        position: 'absolute',
        bottom: theme.spacing(2),
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: theme.spacing(1),
    },
    dot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        cursor: 'pointer',
    },
    activeDot: {
        backgroundColor: '#fff',
    },
    detailsCard: {
        backgroundColor: '#fff',
        padding: theme.spacing(3),
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    detailRow: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        borderBottom: '1px solid #f0f0f0',
        '&:last-child': {
            borderBottom: 'none',
            marginBottom: 0,
            paddingBottom: 0,
        },
    },
    detailIcon: {
        marginRight: theme.spacing(2),
        color: '#666',
    },
    detailLabel: {
        fontWeight: '500',
        color: '#333',
        marginRight: theme.spacing(1),
    },
    detailValue: {
        color: '#666',
    },
    priceSection: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        marginTop: theme.spacing(3),
        paddingTop: theme.spacing(3),
        borderTop: '2px solid #f0f0f0',
    },
    price: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: '#333',
    },
    availability: {
        color: '#4caf50',
        fontWeight: '500',
    },
    bookButton: {
        backgroundColor: '#ff6b81',
        color: '#fff',
        padding: theme.spacing(1.5, 4),
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#ff5570',
        },
    },
    tagsSection: {
        marginTop: theme.spacing(4),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
    },
    tag: {
        backgroundColor: '#333',
        color: '#fff',
        padding: theme.spacing(0.5, 2),
        borderRadius: '20px',
        fontSize: '0.875rem',
    },
    interestSection: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginLeft: 'auto',
    },
    interestButton: {
        border: '1px solid #ff6b81',
        color: '#ff6b81',
        padding: theme.spacing(0.5, 2),
        '&:hover': {
            backgroundColor: '#fff5f7',
        },
    },
    loading: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: '#999',
    },
    error: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: '#d32f2f',
    },
}));

function EventDetails(props) {
    const classes = useStyles();
    const { id } = useParams();
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        if (id) {
            getEventDetails();
        }
    }, [id]);

    const getEventDetails = () => {
        setLoading(true);
        AdminEventService.getAdminEventById(id)
            .then((res) => {
                setEvent(res);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setError('Failed to load event details');
                setLoading(false);
            });
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const options = { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };

    const formatTime = (timeString) => {
        if (!timeString) return '';
        if (timeString.includes(':')) {
            const timeParts = timeString.split(':');
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1] || '00';
            
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            if (hours === 0) {
                hours = 12;
            }
            
            return `${hours}:${minutes} ${ampm}`;
        }
        return timeString;
    };

    const getEventType = (eventName) => {
        const name = eventName.toLowerCase();
        if (name.includes('comedy') || name.includes('standup')) return 'Stand up Comedy';
        if (name.includes('improv')) return 'Improv Comedy';
        if (name.includes('circus')) return 'Circus';
        if (name.includes('concert') || name.includes('jamming') || name.includes('music')) return 'Concerts';
        if (name.includes('workshop')) return 'Workshop';
        if (name.includes('exhibition')) return 'Exhibition';
        return 'Event';
    };

    const handleBack = () => {
        props.history.push('/events');
    };

    const handleShare = () => {
        if (navigator.share) {
            navigator.share({
                title: event?.eventName,
                text: `Check out this event: ${event?.eventName}`,
                url: window.location.href,
            });
        } else {
            navigator.clipboard.writeText(window.location.href);
            alert('Link copied to clipboard!');
        }
    };

    const handleBookNow = () => {
        props.history.push(`/event/${event._id}/booking`);
    };

    const handleInterest = () => {
        // Add interest functionality here
        alert('Interest functionality will be implemented here');
    };

    const images = event?.eventImage ? [event.eventImage] : [];

    if (loading) {
        return (
            <>
                <Header history={props.history} />
                <Box className={classes.container}>
                    <Typography className={classes.loading}>Loading event details...</Typography>
                </Box>
                <Footer />
            </>
        );
    }

    if (error || !event) {
        return (
            <>
                <Header history={props.history} />
                <Box className={classes.container}>
                    <Typography className={classes.error}>{error || 'Event not found'}</Typography>
                    <Button onClick={handleBack} style={{ marginTop: 16 }}>Back to Events</Button>
                </Box>
                <Footer />
            </>
        );
    }

    return (
        <>
            <Header history={props.history} />
            <Box className={classes.container}>
                <div className={classes.contentContainer}>
                    <div className={classes.backButton} onClick={handleBack}>
                        <ArrowBackIcon style={{ marginRight: 8 }} />
                        Back to Events
                    </div>

                    <div className={classes.headerSection}>
                        <Typography className={classes.eventTitle}>
                            {event.eventName}
                        </Typography>
                        <IconButton onClick={handleShare}>
                            <ShareIcon />
                        </IconButton>
                    </div>

                    <Grid container spacing={4}>
                        {/* Left Column - Image */}
                        <Grid item xs={12} md={8}>
                            <div className={classes.imageContainer}>
                                {images.length > 0 ? (
                                    <>
                                        <img
                                            src={images[currentImageIndex]}
                                            alt={event.eventName}
                                            className={classes.eventImage}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                maxHeight: '600px',
                                                minHeight: '400px',
                                                objectFit: 'contain',
                                                objectPosition: 'center',
                                            }}
                                            onError={(e) => {
                                                e.target.src = 'https://via.placeholder.com/800x500?text=No+Image';
                                            }}
                                        />
                                        {images.length > 1 && (
                                            <>
                                                <IconButton
                                                    className={`${classes.carouselButton} ${classes.leftButton}`}
                                                    onClick={() => setCurrentImageIndex((prev) => 
                                                        prev === 0 ? images.length - 1 : prev - 1
                                                    )}
                                                >
                                                    <ArrowBackIosIcon />
                                                </IconButton>
                                                <IconButton
                                                    className={`${classes.carouselButton} ${classes.rightButton}`}
                                                    onClick={() => setCurrentImageIndex((prev) => 
                                                        prev === images.length - 1 ? 0 : prev + 1
                                                    )}
                                                >
                                                    <ArrowForwardIosIcon />
                                                </IconButton>
                                                <div className={classes.carouselDots}>
                                                    {images.map((_, index) => (
                                                        <div
                                                            key={index}
                                                            className={`${classes.dot} ${index === currentImageIndex ? classes.activeDot : ''}`}
                                                            onClick={() => setCurrentImageIndex(index)}
                                                        />
                                                    ))}
                                                </div>
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <img
                                        src="https://via.placeholder.com/800x500?text=No+Image"
                                        alt={event.eventName}
                                        className={classes.eventImage}
                                        style={{
                                            width: '100%',
                                            height: 'auto',
                                            maxHeight: '600px',
                                            minHeight: '400px',
                                            objectFit: 'contain',
                                            objectPosition: 'center',
                                        }}
                                    />
                                )}
                            </div>
                            
                            {/* Special Instructions below image */}
                            {event.specialInstructions && (
                                <Box mt={3} p={2} style={{ backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                                    <Typography variant="h6" gutterBottom style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <InfoIcon style={{ color: '#666' }} />
                                        Special Instructions
                                    </Typography>
                                    <Typography style={{ color: '#666', lineHeight: 1.6 }}>
                                        {event.specialInstructions}
                                    </Typography>
                                </Box>
                            )}
                        </Grid>

                        {/* Right Column - Details */}
                        <Grid item xs={12} md={4}>
                            <div className={classes.detailsCard}>
                                <div className={classes.detailRow}>
                                    <CalendarTodayIcon className={classes.detailIcon} />
                                    <Typography className={classes.detailValue}>
                                        {formatDate(event.fromDate)}
                                        {event.toDate && event.fromDate !== event.toDate && ` - ${formatDate(event.toDate)}`}
                                    </Typography>
                                </div>

                                {event.fromTime && (
                                    <div className={classes.detailRow}>
                                        <AccessTimeIcon className={classes.detailIcon} />
                                        <Typography className={classes.detailValue}>
                                            {formatTime(event.fromTime)}
                                            {event.toTime && ` - ${formatTime(event.toTime)}`}
                                        </Typography>
                                    </div>
                                )}

                                {/* <div className={classes.detailRow}>
                                    <HourglassEmptyIcon className={classes.detailIcon} />
                                    <Typography className={classes.detailValue}>1 Hour</Typography>
                                </div>

                                <div className={classes.detailRow}>
                                    <PersonIcon className={classes.detailIcon} />
                                    <Typography className={classes.detailValue}>All Ages</Typography>
                                </div>

                                <div className={classes.detailRow}>
                                    <LanguageIcon className={classes.detailIcon} />
                                    <Typography className={classes.detailValue}>English</Typography>
                                </div> */}

                                <div className={classes.detailRow}>
                                    <LocationOnIcon className={classes.detailIcon} />
                                    <Typography className={classes.detailValue}>
                                        {event.venue}
                                        {event.city && `, ${event.city}`}
                                    </Typography>
                                </div>

                                {(event.geoLocation?.latitude || event.geoLocation?.longitude) && (
                                    <>
                                        {event.geoLocation?.latitude && (
                                            <div className={classes.detailRow}>
                                                <MyLocationIcon className={classes.detailIcon} />
                                                <Typography className={classes.detailLabel}>Latitude:</Typography>
                                                <Typography className={classes.detailValue}>
                                                    {event.geoLocation.latitude}
                                                </Typography>
                                            </div>
                                        )}
                                        {event.geoLocation?.longitude && (
                                            <div className={classes.detailRow}>
                                                <MyLocationIcon className={classes.detailIcon} />
                                                <Typography className={classes.detailLabel}>Longitude:</Typography>
                                                <Typography className={classes.detailValue}>
                                                    {event.geoLocation.longitude}
                                                </Typography>
                                            </div>
                                        )}
                                    </>
                                )}

                                <div className={classes.detailRow}>
                                    <Typography className={classes.detailLabel}>Category:</Typography>
                                    <Typography className={classes.detailValue}>
                                        {event.category || getEventType(event.eventName)}
                                    </Typography>
                                </div>

                                {/* <div className={classes.priceSection}>
                                    <Typography className={classes.price}>₹ 399</Typography>
                                    <Typography className={classes.availability}>Available</Typography>
                                    <Button
                                        className={classes.bookButton}
                                        variant="contained"
                                        onClick={handleBookNow} 
                                    >
                                        Book Now
                                    </Button>
                                </div> */}
                            </div>
                        </Grid>
                    </Grid>

                    {/* Bottom Section - Tags and Interest */}
                    {/* <div className={classes.tagsSection}>
                        <Chip label={getEventType(event.eventName)} className={classes.tag} />
                        <Chip label="Comedy Shows" className={classes.tag} />
                        <div className={classes.interestSection}>
                            <ThumbUpIcon style={{ color: '#4caf50', marginRight: 4 }} />
                            <Typography style={{ color: '#666' }}>124 are interested</Typography>
                            <Button
                                className={classes.interestButton}
                                variant="outlined"
                                onClick={handleInterest}
                            >
                                I'm Interested
                            </Button>
                        </div>
                    </div> */}

                </div>
            </Box>
            <Footer />
        </>
    );
}

export default withRouter(EventDetails);

